/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
// sepertinya tidak terpakai

import React from 'react';

import {connect} from 'react-redux';
import Select from 'react-select';
import {bindActionCreators} from 'redux';

import {showModal} from '@/actions/modalActions';
import {
  PostEnableManualUpdate,
  PostStartManualUpdate,
  PostStopManualUpdate,
  PostCancelManualControl,
} from '@/businesses/fetchManualControl';
import ToggleButtonCustom from '@/components/togglebutton/src/ToggleButtonCustom';
import * as APPDATA from '@/constants/pcConstAppData';
import {consoleLog} from '@/libs/consoleHelper';
import {eventBusObject} from '@/observers/eventBus';

import {
  postEnableManualControl,
  postStartManualControl,
  postStopManualControl,
  getStatusManualControl,
  getTotalRuntimeManualControl,
  getCancelManualControl,
} from '../../../stores/reducers/manualControlStore';

import '../StatusPage.less';

export const MANUAL_CONTROL = 'MANUAL CONTROL';
export const SWITCH_TO_MANUAL_CONTROL = 'SWITCH TO MANUAL';
export const MANUAL_CONTROL_ENUM = {
  HOLD_TO_RUN: 3,
  CUSTOM_VOLUME_MANUAL_CONTROL: 2,
  DEFAULT_VOLUME_MANUAL_CONTROL: 1,
};
// TIME IN MS
const DEFAULT_VOLUME_MANUAL_CONTROL = [
  {
    label: `0.2 ${APPDATA.UNIT.ml}`,
    value: '0.2',
  },
  {
    label: `0.5 ${APPDATA.UNIT.ml}`,
    value: '0.5',
  },
  {
    label: `1 ${APPDATA.UNIT.ml}`,
    value: '1',
  },
  {
    label: `2 ${APPDATA.UNIT.ml}`,
    value: '2',
  },
];

class ManualControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedManualControl: MANUAL_CONTROL_ENUM.DEFAULT_VOLUME_MANUAL_CONTROL,
      selectedDefaultVolume: DEFAULT_VOLUME_MANUAL_CONTROL[0].value,
      volumeInMl: DEFAULT_VOLUME_MANUAL_CONTROL[0].value,
      isHoldnRunActive: false,
    };
    this._bus = eventBusObject();
    // this._counterHoldAndRun = 1;
  }

  componentDidMount() {
    this.eventEnablemanualControl = this._bus.subscribe(ManualControlEvent.EnableManualControl, () =>
      this.EnableManualUpdate(),
    );
    this.eventStartManualControl = this._bus.subscribe(ManualControlEvent.StartManualControl, () =>
      this.StartManualControl(),
    );
    this.eventStopManualControl = this._bus.subscribe(ManualControlEvent.StopManualControl, () =>
      this.StopManualControl(),
    );
    this.eventStartManualControlOnHold = this._bus.subscribe(ManualControlEvent.StartManualControlOnHold, () =>
      this.StartManualControlOnHold(),
    );
    this.eventStopManualControlOnHold = this._bus.subscribe(ManualControlEvent.StopManualControlOnHold, () =>
      this.StopManualControlOnHold(),
    );
    this.eventCancelManualControl = this._bus.subscribe(ManualControlEvent.CancelManualControl, () =>
      this.CancelManualControl(),
    );
  }

  shouldComponentUpdate(nextProps, nextState) {
    // if (this.props.enableManualControl !== nextProps.enableManualControl)
    //     return true
    // if (this.props.startManualControl !== nextProps.startManualControl)
    //     return true
    // if (this.props.stopManualControl !== nextProps.stopManualControl)
    //     return true
    // if (this.props.cancelManualControl !== nextProps.cancelManualControl)
    //     return true
    if (this.props.statusManualControl.IsManualControlRunning !== nextProps.statusManualControl.IsManualControlRunning)
      return true;

    if (this.props.totalRunTimemanualControl !== nextProps.totalRunTimemanualControl) return true;
    if (this.props.concentrationFlowRate !== nextProps.concentrationFlowRate) return true;
    if (this.state.isHoldnRunActive !== nextState.isHoldnRunActive) return true;
    if (this.state.volumeInMl !== nextState.volumeInMl) return true;
    if (this.state.selectedDefaultVolume !== nextState.selectedDefaultVolume) return true;
    if (this.state.selectedManualControl !== nextState.selectedManualControl) return true;
    if (this.props.showManualControl !== nextProps.showManualControl) return true;

    return false;
  }

  componentWillUnmount() {
    this.eventEnablemanualControl.unsubscribe();
    this.eventStartManualControl.unsubscribe();
    this.eventStopManualControl.unsubscribe();
    this.eventStartManualControlOnHold.unsubscribe();
    this.eventStopManualControlOnHold.unsubscribe();
    this.eventCancelManualControl.unsubscribe();
  }

  // subscriber
  EnableManualUpdate = () => {
    const {PostEnableManualUpdate} = this.props;
    consoleLog('EnableManualUpdate StatusManualControl', this.props.RequestPendingManualControl);
    if (!this.props.RequestPendingManualControl) {
      PostEnableManualUpdate();
    }
  };

  StartManualControl = () => {
    const {PostStartManualUpdate} = this.props;
    if (!this.props.RequestPendingManualControl) {
      const param = {
        TotRunTime: this.state.volumeInMl,
      };
      PostStartManualUpdate(param);
    }
  };

  StopManualControl = () => {
    const {PostStopManualUpdate} = this.props;

    if (!this.props.RequestPendingManualControl) {
      PostStopManualUpdate();
      this._bus.publish(APPDATA.EVENT.TopButtonStatusType, MANUAL_CONTROL_ENUM.DEFAULT_VOLUME_MANUAL_CONTROL);
    }
  };

  CancelManualControl = () => {
    const {PostCancelManualControl} = this.props;

    if (!this.props.RequestPendingManualControl) {
      PostCancelManualControl();
    }
  };

  StartManualControlOnHold = () => {
    if (this.state.isHoldnRunActive === false) {
      this.setState({
        isHoldnRunActive: true,
      });
      this.poolingOnHoldManualControl = setInterval(() => this.actionOnHoldManualControl(), 500);
    }
  };

  StopManualControlOnHold = () => {
    if (this.state.isHoldnRunActive === true) {
      this.setState({
        isHoldnRunActive: false,
      });
      clearTimeout(this.poolingOnHoldManualControl);
    }
  };

  actionOnHoldManualControl = () => {
    this.StartManualControl();
    // this._counterHoldAndRun += 1;
  };

  // end subscriber
  onClickToggleButton = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.ENUM.MANUAL_CONTROL.DEFAULT_VOLUME_MANUAL_CONTROL:
        this.setState({
          selectedManualControl: MANUAL_CONTROL_ENUM.DEFAULT_VOLUME_MANUAL_CONTROL,
          volumeInMl: this.state.selectedDefaultVolume,
        });
        this._bus.publish(APPDATA.EVENT.TopButtonStatusType, MANUAL_CONTROL_ENUM.DEFAULT_VOLUME_MANUAL_CONTROL);
        break;
      case APPDATA.ENUM.MANUAL_CONTROL.CUSTOM_VOLUME_MANUAL_CONTROL:
        this.setState({
          selectedManualControl: MANUAL_CONTROL_ENUM.CUSTOM_VOLUME_MANUAL_CONTROL,
          volumeInMl: this.state.volumeInMl === '210' ? '1' : this.state.volumeInMl,
        });
        this._bus.publish(APPDATA.EVENT.TopButtonStatusType, MANUAL_CONTROL_ENUM.CUSTOM_VOLUME_MANUAL_CONTROL);
        break;
      case APPDATA.ENUM.MANUAL_CONTROL.HOLD_TO_RUN:
        this.setState({selectedManualControl: MANUAL_CONTROL_ENUM.HOLD_TO_RUN, volumeInMl: '210'});
        this._bus.publish(APPDATA.EVENT.TopButtonStatusType, MANUAL_CONTROL_ENUM.HOLD_TO_RUN);
        break;
      default:
        break;
    }
    // this._counterHoldAndRun = 1;
  };

  onChangeManualControlVolume = (e) => {
    this.setState({
      selectedDefaultVolume: e.value,
      volumeInMl: e.value,
    });
  };

  onClickInputCustomTime = () => {
    const {showNumpad} = this.props;
    showNumpad({
      modalHeader: 'Total Volume',
      value: this.state.volumeInMl,
      callback: this.onChangeVolumeManualControl,
      maxValue: 100,
      minValue: 0.1,
      maxDigitAfterDecimal: 1,
      unit: APPDATA.UNIT.ml,
    });
  };

  onChangeVolumeManualControl = (e) => {
    switch (e.type) {
      case 'Total Volume':
        this.setState({volumeInMl: e.value});
        break;
      default:
        break;
    }
  };
  // calculateEstimateConcentratedSample = () => {
  // 	const { concentrationFlowRate } = this.props;
  // 	const { volumeInMl: volumeInMl } = this.state;
  // 	var concentratePerMin = concentrationFlowRate;
  // 	concentratePerMin = concentrationFlowRate === undefined ? -1 : concentrationFlowRate.replace(",", "."); //data from backend using ,
  // 	var timePeriodInS = volumeInMl;

  // 	var estSampleAddded = (concentratePerMin / 60) * timePeriodInS;
  // 	var resultOfEstimate = 0;
  // 	var digitPrecision = this.getTotalDecimal(estSampleAddded);
  // 	if (estSampleAddded === 0 || this.state.selectedManualControl === MANUAL_CONTROL_ENUM.HOLD_TO_RUN) {
  // 		resultOfEstimate = "N/A";
  // 	} else {
  // 		var calculation = estSampleAddded.toPrecision(digitPrecision) * this._counterHoldAndRun;
  // 		var calculationDigitPrecision = this.getTotalDecimal(calculation);
  // 		resultOfEstimate = calculation.toPrecision(calculationDigitPrecision);
  // 	}
  // 	return resultOfEstimate;
  // };
  //   getTotalDecimal = (number) => {
  //     if (number === undefined) return 0;
  //     const digitPrecision = `${number}`.split('.')[0].length;
  //     return digitPrecision;
  //   };

  disableManualControlToggle = () => {
    const {statusManualControl} = this.props;

    if (this.state.selectedManualControl === MANUAL_CONTROL_ENUM.HOLD_TO_RUN) {
      if (this.state.isHoldnRunActive) return true;
      return false;
    }
    if (statusManualControl.IsManualControlRunning === 'true') return true;
    return false;
  };

  manualControlView = () => {
    const {selectedManualControl} = this.state;
    const disableToggleButtonManualControl = this.disableManualControlToggle();
    const ManualTimeProps = [
      {
        label: APPDATA.ENUM.MANUAL_CONTROL.DEFAULT_VOLUME_MANUAL_CONTROL,
        value: MANUAL_CONTROL_ENUM.DEFAULT_VOLUME_MANUAL_CONTROL,
        customButtonSize: true,
        disabled: disableToggleButtonManualControl,
      },
      {
        label: APPDATA.ENUM.MANUAL_CONTROL.CUSTOM_VOLUME_MANUAL_CONTROL,
        value: MANUAL_CONTROL_ENUM.CUSTOM_VOLUME_MANUAL_CONTROL,
        customButtonSize: true,
        disabled: disableToggleButtonManualControl,
      },
      {
        label: APPDATA.ENUM.MANUAL_CONTROL.HOLD_TO_RUN,
        value: MANUAL_CONTROL_ENUM.HOLD_TO_RUN,
        customButtonSize: true,
        disabled: disableToggleButtonManualControl,
      },
    ];
    const disabledTotalRunTimeField = selectedManualControl === MANUAL_CONTROL_ENUM.HOLD_TO_RUN;
    const TotalRunTimeViewValue = disabledTotalRunTimeField ? '' : `${this.state.volumeInMl} ${APPDATA.UNIT.ml}`;
    const InputTimePeriod =
      selectedManualControl === MANUAL_CONTROL_ENUM.DEFAULT_VOLUME_MANUAL_CONTROL ? (
        <Select
          id="ManualControlDefaultVolume"
          name="form-field-name"
          options={DEFAULT_VOLUME_MANUAL_CONTROL}
          className="selectField"
          value={this.state.selectedDefaultVolume}
          onChange={this.onChangeManualControlVolume}
          clearable={false}
          searchable={false}
          placeholder=""
          disabled={disableToggleButtonManualControl}
          // set selector to up
          menuContainerStyle={{top: 'auto', bottom: '100%', width: '150px', left: '-30px', maxHeight: '600px'}}
        />
      ) : (
        <input
          value={TotalRunTimeViewValue}
          id="TotalRunTime"
          className="TotalRunTimeField"
          readOnly
          onClick={disableToggleButtonManualControl ? () => {} : this.onClickInputCustomTime}
          disabled={disabledTotalRunTimeField}
        />
      );
    consoleLog('DEFAULT_VOLUME_MANUAL_CONTROL', {DEFAULT_VOLUME_MANUAL_CONTROL, InputTimePeriod});
    const displayView = this.props.showManualControl ? '' : 'none';

    const style = {
      constraint: {
        display: displayView,
      },
    };
    // const styleEditionConcSample = {
    //   constraint: {
    //     padding: displayView,
    //   },
    // };
    return (
      <div style={style.constraint}>
        <div className="row center row-manual-control">
          <div className="col-md-10">
            <ToggleButtonCustom
              buttonProp={ManualTimeProps}
              defaultValue={MANUAL_CONTROL_ENUM.DEFAULT_VOLUME_MANUAL_CONTROL}
              value={selectedManualControl}
              onClick={this.onClickToggleButton}
              disabled={disableToggleButtonManualControl}
            />
          </div>
          <div className="col-md-2 no-padding">{InputTimePeriod}</div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <span>{`Estimate Additional Concentrated Sample : ${this.state.selectedDefaultVolume} mL`}</span>
          </div>
        </div>
      </div>
    );
  };

  render() {
    return this.manualControlView();
  }
}
const mapStateToProps = (state) => ({
  enableManualControl: postEnableManualControl(state),
  startManualControl: postStartManualControl(state),
  stopManualControl: postStopManualControl(state),
  cancelManualControl: getCancelManualControl(state),
  statusManualControl: getStatusManualControl(state),
  totalRunTimemanualControl: getTotalRuntimeManualControl(state),
  concentrationFlowRate: state.setupStore.concentrationFlowRate,
  IsHoldToRunActive: state.manualControlStore.IsHoldToRunActive,
  RequestPendingManualControl: state.manualControlStore.RequestPendingManualControl,
});
// research again, why this not working
const mapDispatchToProps = (dispatch) => ({
  PostEnableManualUpdate: bindActionCreators(PostEnableManualUpdate, dispatch),
  PostStartManualUpdate: bindActionCreators(PostStartManualUpdate, dispatch),
  PostStopManualUpdate: bindActionCreators(PostStopManualUpdate, dispatch),
  PostCancelManualControl: bindActionCreators(PostCancelManualControl, dispatch),
  showNumpad: bindActionCreators(showModal, dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(ManualControl);

export const ManualControlEvent = {
  EnableManualControl: 'EnableManualControl',
  StartManualControl: 'StartManualControl',
  StopManualControl: 'StopManualControl',
  CancelManualControl: 'CancelManualControl',
  StartManualControlOnHold: 'StartManualControlOnHold',
  StopManualControlOnHold: 'StopManualControlOnHold',
};
